import get from 'lodash/get'

export const getMessage = (state: Object) => get(state, 'snackbar.message')
export const getShow = (state: Object) => get(state, 'snackbar.show')
export const getSeverity = (state: Object) => get(state, 'snackbar.severity')
